/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { ChangeEvent } from "react";

export const trimTransform = {
  input: (val: string | undefined) => val?.trim() ?? "",
  output: (e: ChangeEvent<HTMLInputElement>) => e.target.value?.trim(),
};
